/* eslint-disable @typescript-eslint/no-shadow */
import type { Collection } from '../../../../collection'
import type * as ecModels from '../../../../models'

export type EntitySelection<
  TTypeParams extends ecModels.TypeParams.Constraint,
> = ExactlyOneOf<
  EntitySelection.ForIdentifier & EntitySelection.ForObject<TTypeParams>
>
export namespace EntitySelection {
  export type Normalized = readonly ecModels.EntityId[]
  export function normalize<
    TTypeParams extends ecModels.TypeParams.Constraint,
  >({
    entity,
    entities,
    entityId,
    entityIds,
    collection,
  }: EntitySelection<TTypeParams> & {
    collection: Collection<TTypeParams>
  }): Normalized {
    if (entity) {
      entityIds = [collection.identify(entity)]
    }
    if (entities) {
      entityIds = entities.map(e => collection.identify(e))
    }
    if (entityId) {
      entityIds = [entityId]
    }

    return entityIds ?? []
  }

  export type ForObject<TTypeParams extends ecModels.TypeParams.Constraint> =
    ExactlyOneOf<{
      readonly entity: TTypeParams['entity']
      readonly entities: readonly TTypeParams['entity'][]
    }>
  export namespace ForObject {
    export type Normalized = readonly ecModels.EntityId[]

    export function normalize<
      TTypeParams extends ecModels.TypeParams.Constraint,
    >(value: ForObject<TTypeParams>): Normalized {
      return value.entities ?? [value.entity]
    }
  }
  export type ForIdentifier = ExactlyOneOf<{
    readonly entityId: ecModels.EntityId
    readonly entityIds: readonly ecModels.EntityId[]
  }>
  export namespace ForIdentifier {
    export type Normalized = readonly ecModels.EntityId[]
    // eslint-disable-next-line jsdoc/require-jsdoc
    export function normalize(value: ForIdentifier): Normalized {
      return value.entityIds ?? [value.entityId]
    }
  }
}
